import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";
import Select from "react-select";
import BackLink from "../../layouts/components/BackLink";
const REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

const fetchRegions = async (
  filters: Record<string, string | number | null> = {}
) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== null && value !== ""
      )
    ) as Record<string, string>
  ).toString();

  const res = await fetch(
    `${REACT_APP_BASE_API_URL}/v1/regions?${queryString}`,
    {
      cache: "no-cache",
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch data");
  }

  return res.json();
};

const fetchMakes = async (
  filters: Record<string, string | number | null> = {}
) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== null && value !== ""
      )
    ) as Record<string, string>
  ).toString();

  const res = await fetch(`${REACT_APP_BASE_API_URL}/v1/makes?${queryString}`, {
    cache: "no-cache",
  });

  if (!res.ok) {
    throw new Error("Failed to fetch data");
  }

  return res.json();
};

const fetchBraches = async (
  filters: Record<string, string | number | null> = {}
) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(filters).filter(
        ([_, value]) => value !== null && value !== ""
      )
    ) as Record<string, string>
  ).toString();

  const res = await fetch(
    `${REACT_APP_BASE_API_URL}/v1/branches?${queryString}`,
    {
      cache: "no-cache",
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch data");
  }

  return res.json();
};

const fetchEntry = async (id: string) => {
  const res = await fetch(`${REACT_APP_BASE_API_URL}/v1/entries/${id}`, {
    cache: "no-cache",
  });

  if (!res.ok) {
    throw new Error("Failed to fetch data");
  }

  return res.json();
};

const handleSubmitData = async (id: string, data: any) => {
  const res = await fetch(
    `${REACT_APP_BASE_API_URL}/v1/entries/${id}?source="webform"`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );

  if (!res.ok) {
    throw new Error("Failed to submit data");
  }
  return res.json();
};

const Update = () => {
  const [region, setRegion] = useState("");
  const [district, setDistrict] = useState("");
  const [ward, setWard] = useState("");
  const [name, setName] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [registration, setRegistration] = useState<string>("");
  const [make, setMake] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [branch, setBranch] = useState<string>("");
  const [mileage, setMileage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [regions, setRegions] = useState([]);
  const [makes, setMakes] = useState<any>([]);
  const [gender, setGender] = useState<any>([]);
  const [branches, setBranches] = useState<any>([]);
  const [year, setYear] = useState<string>("");
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitted, setSubmitted] = useState<boolean>(false);
  const [entry, setEntry] = useState<any>(null);
  const { id } = useParams();

  const clearForm = () => {
    setName("");
    setMobile("");
    setRegistration("");
    setRegion("");
    setDistrict("");
    setWard("");
    setMake("");
    setModel("");
  };

  const selectedRegion: any = regions.find((r: any) => r._id === region);
  const districts = selectedRegion ? selectedRegion.districts : [];
  const selectedDistrict = districts.find((d: any) => d._id === district);
  const wards = selectedDistrict ? selectedDistrict.wards : [];

  const selectedMake: any = makes.find((r: any) => r._id === make);
  const models = selectedMake ? selectedMake.models : [];
  const c = new Date().getFullYear();
  const years = Array.from({ length: 26 }, (_, i) => c - i);

  const handleSubmit = async (e: any) => {
    try {
      e.preventDefault();
      setLoading(true);
      if (!name) {
        setLoading(false);
        return toast.error("Please enter your name");
      }
      if (!mobile) {
        setLoading(false);
        return toast.error("Please enter mobile number");
      }
      const data = {
        name,
        mobile,
        registration,
        region,
        district,
        branch,
        gender,
        ward,
        make,
        model,
        year,
        mileage,
      };

      const res = await handleSubmitData(id || "", data);
      setLoading(false);

      if (res) {
        toast.success("Your Entry was updated");
        clearForm();
      }
    } catch (error) {
      toast.error("Something went wrong");
      setLoading(false);
    }
  };

  const regionOptions = regions.map((item: any) => ({
    value: item?._id,
    label: item?.name,
  }));

  const branchOptions = branches.map((item: any) => ({
    value: item?._id,
    label: item?.name,
  }));

  const districtOptions = districts.map((item: any) => ({
    value: item?._id,
    label: item?.name,
  }));

  const wardOptions = wards.map((item: any) => ({
    value: item?._id,
    label: item?.name,
  }));

  const makeOptions = makes.map((make: any) => ({
    value: make?._id,
    label: make?.name,
  }));

  const modelOptions = models.map((model: any) => ({
    value: model?._id,
    label: model?.name,
  }));

  const yearOptions = years.map((year: number) => ({
    value: year,
    label: year,
  }));

  useEffect(() => {
    const loadRegions = async () => {
      try {
        setLoading(true);
        const records = await fetchRegions();
        setRegions(records);
      } catch (error) {
        console.error("Failed to load regions:", error);
      } finally {
        setLoading(false);
      }
    };

    loadRegions();
  }, []);

  useEffect(() => {
    const loadMakes = async () => {
      try {
        setLoading(true);
        const records = await fetchMakes();
        setMakes(records);
      } catch (error) {
        console.error("Failed to load makes:", error);
      } finally {
        setLoading(false);
      }
    };

    loadMakes();
  }, []);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        setLoading(true);
        const records = await fetchBraches();
        setBranches(records);
      } catch (error) {
        console.error("Failed to load makes:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBranches();
  }, []);

  useEffect(() => {
    const loadEntry = async () => {
      try {
        const records = await fetchEntry(id || "");
        setEntry(records);
      } catch (error) {
        console.error("Failed to load entry:", error);
      }
    };

    loadEntry();
  }, [id]);

  useEffect(() => {
    if (entry) {
      setName(entry.name || "");
      setMobile(entry.mobile || "");
      setRegistration(entry.registration || "");
      setRegion(entry.region || "");
      setDistrict(entry.district || "");
      setWard(entry.ward || "");
      setMake(entry.make || "");
      setModel(entry.model || "");
      setBranch(entry.branch || "");
      setMileage(entry.mileage || "");
      setGender(entry.gender || "");
      setYear(entry.year || "");
    }
  }, [entry]);

  return (
    <div className="">
      <div className="bg-white border m-1">
        <div className="flex flex-col sm:flex-row justify-between items-center border px-2">
          <div className="">
            <div className="font-bold capitalize text-lg">Update Entries</div>
            <div className="text-gray-600 mb-1">Update entry</div>
          </div>
        </div>
        <BackLink to="/entries" />

        <form
          className="max-w-md mx-auto p-4 mb-16 mt-4 bg-white shadow-lg border rounded-md"
          onSubmit={handleSubmit}
        >
          <h1 className="text-lg font-bold mb-4 text-center border-b-4 pb-2 border-autoinc-orange">
            CUSTOMER FORM
          </h1>
          <Toaster />
          <div>
            <div className="mt-3">
              <label className="font-bold">BRANCH SERVED</label>
              <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                <Select
                  className="w-full"
                  options={branchOptions}
                  value={branchOptions.find(
                    (option: any) => option.value === branch
                  )}
                  onChange={(selectedOption: any) =>
                    setBranch(selectedOption?.value || "")
                  }
                  placeholder="Select branch"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      border: "none",
                      boxShadow: "none",
                      padding: "0",
                      minHeight: "unset",
                    }),
                    dropdownIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    clearIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    indicatorsContainer: (provided: any) => ({
                      ...provided,
                      paddingRight: 8,
                    }),
                  }}
                />
              </div>
            </div>
            <div className="mt-3">
              <label className="text-xxs">FULL NAME</label>
              <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                <input
                  type="text"
                  placeholder="Type your full name"
                  className="px-2 py-1 focus:outline-none"
                  style={{ fontSize: 14, width: "100%" }}
                  value={name}
                  onChange={(e: any) => setName(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-3">
              <label className="text-xxs">PHONE NUMBER</label>
              <div className="border border-gray-400 bg-white">
                <input
                  type="text"
                  placeholder="Type your phone number"
                  className="px-2 py-1 focus:outline-none"
                  style={{ fontSize: 14, width: "100%" }}
                  value={mobile}
                  onChange={(e: any) => setMobile(e.target.value)}
                />
              </div>
            </div>

            <div className="mt-3">
              <label className="block text-xxs font-bold mb-2">GENDER</label>
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    checked={gender === "male"}
                    onChange={() => setGender("male")}
                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <span className="ml-2">Male</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    checked={gender === "female"}
                    onChange={() => setGender("female")}
                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <span className="ml-2">Female</span>
                </label>
              </div>
            </div>

            <div className="mt-3">
              <label className="text-xxs">CAR REGISTRATION</label>
              <div className="border border-gray-400 mt-1 bg-white">
                <input
                  type="text"
                  placeholder="Type your email address"
                  className="px-2 py-1 focus:outline-none"
                  style={{ fontSize: 14, width: "100%" }}
                  value={registration}
                  onChange={(e: any) => setRegistration(e.target.value)}
                />
              </div>
            </div>

            <button
              type="button"
              className="mt-3 p-2 bg-autoinc-orange text-white"
              onClick={() => setShowPopup(true)}
            >
              Add Make & Model
            </button>
            <div className="mt-3">
              <label>REGION</label>
              <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                <Select
                  className="w-full py-1"
                  options={regionOptions}
                  value={regionOptions.find(
                    (option: any) => option.value === region
                  )}
                  onChange={(selectedOption: any) =>
                    setRegion(selectedOption?.value || "")
                  }
                  placeholder="Select region"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      border: "none",
                      boxShadow: "none",
                      padding: "0",
                      minHeight: "unset",
                    }),
                    dropdownIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    clearIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    indicatorsContainer: (provided: any) => ({
                      ...provided,
                      paddingRight: 8,
                    }),
                  }}
                />
              </div>
            </div>
            <div className="mt-3">
              <label>DISTRICT</label>
              <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                <Select
                  className="w-full py-1"
                  options={districtOptions}
                  value={districtOptions.find(
                    (option: any) => option.value === district
                  )}
                  onChange={(selectedOption: any) =>
                    setDistrict(selectedOption?.value || "")
                  }
                  placeholder="Select district"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      border: "none",
                      boxShadow: "none",
                      padding: "0",
                      minHeight: "unset",
                    }),
                    dropdownIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    clearIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    indicatorsContainer: (provided: any) => ({
                      ...provided,
                      paddingRight: 8,
                    }),
                  }}
                />
              </div>
            </div>
            <div className="mt-3">
              <label>WARD</label>
              <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                <Select
                  className="w-full py-1"
                  options={wardOptions}
                  value={wardOptions.find(
                    (option: any) => option.value === ward
                  )}
                  onChange={(selectedOption: any) =>
                    setWard(selectedOption?.value || "")
                  }
                  placeholder="Select ward"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      border: "none",
                      boxShadow: "none",
                      padding: "0",
                      minHeight: "unset",
                    }),
                    dropdownIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    clearIndicator: (provided: any) => ({
                      ...provided,
                      padding: 4,
                    }),
                    indicatorsContainer: (provided: any) => ({
                      ...provided,
                      paddingRight: 8,
                    }),
                  }}
                />
              </div>
            </div>

            {showPopup && (
              <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center -mr-56">
                <div
                  className="bg-white p-6 rounded shadow-md"
                  style={{ width: "90%", maxWidth: "calc(0.9 * 28rem)" }}
                >
                  <h2 className="text-lg font-bold mb-4">
                    Add More Car Details
                  </h2>
                  <div className="mb-2">
                    <label className="font-bold">MAKE</label>
                    <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                      <Select
                        className="w-full"
                        options={makeOptions}
                        value={makeOptions.find(
                          (option: any) => option.value === make
                        )}
                        onChange={(selectedOption: any) =>
                          setMake(selectedOption?.value || "")
                        }
                        placeholder="Select make"
                        isClearable
                        isSearchable
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                            padding: "0",
                            minHeight: "unset",
                          }),
                          dropdownIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          clearIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          indicatorsContainer: (provided: any) => ({
                            ...provided,
                            paddingRight: 8,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label className="font-bold">MODEL</label>
                    <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                      <Select
                        className="w-full"
                        options={modelOptions}
                        value={modelOptions.find(
                          (option: any) => option.value === model
                        )}
                        onChange={(selectedOption: any) =>
                          setModel(selectedOption?.value || "")
                        }
                        placeholder="Select model"
                        isClearable
                        isSearchable
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                            padding: "0",
                            minHeight: "unset",
                          }),
                          dropdownIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          clearIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          indicatorsContainer: (provided: any) => ({
                            ...provided,
                            paddingRight: 8,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-2">
                    <label className="font-bold">YEAR</label>
                    <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                      <Select
                        className="w-full"
                        options={yearOptions}
                        value={yearOptions.find(
                          (option: any) => option.value === year
                        )}
                        onChange={(selectedOption: any) =>
                          setYear(selectedOption?.value || "")
                        }
                        placeholder="Select year"
                        isClearable
                        isSearchable
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            border: "none",
                            boxShadow: "none",
                            padding: "0",
                            minHeight: "unset",
                          }),
                          dropdownIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          clearIndicator: (provided: any) => ({
                            ...provided,
                            padding: 4,
                          }),
                          indicatorsContainer: (provided: any) => ({
                            ...provided,
                            paddingRight: 8,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-5">
                    <label className="text-xxs font-bold">MILEAGE</label>
                    <div className="border border-gray-400 pr-2 bg-white focus:border-autoinc">
                      <input
                        type="number"
                        placeholder="Type your mileage"
                        className="px-2 py-1 focus:outline-none text-xxs"
                        style={{ fontSize: 12, width: "100%" }}
                        value={mileage}
                        onChange={(e: any) => setMileage(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2">
                    <button
                      type="button"
                      className="p-2 bg-gray-300"
                      onClick={() => setShowPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="p-2 bg-green-500 hover:bg-green-600 text-white"
                      onClick={() => setShowPopup(false)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <button
            type="submit"
            className="mt-4 w-full p-2 bg-green-500 text-white"
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default Update;
